/**
 * 题目主标题富文本只读渲染：编辑端预览与填写端共用。
 * - 兼容 string（按纯文本转义）与 RichText（html 优先，缺失则按 format 构造）
 * - 标题说明 / 分页栏也用这个组件（题目块的居中大标题展示）
 */
import { type TitleLike, titleHTML } from './types';

type Props = {
  value: TitleLike | undefined | null;
  className?: string;
  /** 是否在题目块顶部居中显示（标题说明 / 分页栏的视觉差异） */
  variant?: 'inline' | 'statement';
};

export default function RichTextView({ value, className, variant = 'inline' }: Props) {
  const html = titleHTML(value);
  const cn = ['rich-text-view', `is-${variant}`, className].filter(Boolean).join(' ');
  // 关键：渲染从已经过 escapeHTML / 预生成的内联 HTML，禁止 dangerouslySetInnerHTML 接受任意外部内容；
  // 仅暴露 titleHTML 自有管道
  return <div className={cn} dangerouslySetInnerHTML={{ __html: html }} />;
}